export default "__VITE_ASSET__5c1f46d6__"